import { OnboardingApplication } from "@dreambigger/shared/src/types";

/**
 * Module-level singleton that holds the in-flight admin-edit application
 * context. `AdminApplicationWrapper` (a React component) sets these fields
 * on mount and clears them on unmount; non-React callers (display-condition
 * evaluators, server-style helpers, tests) read via the exported getters
 * below.
 *
 * Lives in a plain `.ts` file (not the JSX-bearing wrapper) so jest and
 * other non-React import paths can pull the helpers without dragging the
 * React component into their transform graph.
 */
const adminApplicationStore: {
  application: OnboardingApplication | null;
  financialInstitutionId: string | null;
} = {
  application: null,
  financialInstitutionId: null,
};

export const setAdminApplication = (
  application: OnboardingApplication | null,
  financialInstitutionId: string | null
): void => {
  adminApplicationStore.application = application;
  adminApplicationStore.financialInstitutionId = financialInstitutionId;
};

export const getAdminApplication = (): OnboardingApplication | null =>
  adminApplicationStore.application;

export const getAdminFinancialInstitutionId = (): string | null =>
  adminApplicationStore.financialInstitutionId;

export const isInAdminMode = (): boolean =>
  adminApplicationStore.application !== null;
